import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-[#0B0B0B]/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="text-white font-bold text-2xl cursor-pointer" onClick={() => scrollToSection('hero')}>
            <span className="text-[#2563EB]">FIT</span>CREATOR
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('about')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium"
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('audience')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium"
            >
              Audience
            </button>
            <button
              onClick={() => scrollToSection('case-studies')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium"
            >
              Case Studies
            </button>
            <button
              onClick={() => scrollToSection('collaborate')}
              className="text-white/80 hover:text-white transition-colors duration-200 text-sm font-medium"
            >
              Collaborate
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white px-6 py-2 rounded-md transition-all duration-200 shadow-lg hover:shadow-[#2563EB]/50"
            >
              Get Started
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-[#0B0B0B]/98 backdrop-blur-md border-t border-white/10">
            <nav className="flex flex-col space-y-4 px-4 py-6">
              <button
                onClick={() => scrollToSection('about')}
                className="text-white/80 hover:text-white transition-colors duration-200 text-left"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection('audience')}
                className="text-white/80 hover:text-white transition-colors duration-200 text-left"
              >
                Audience
              </button>
              <button
                onClick={() => scrollToSection('case-studies')}
                className="text-white/80 hover:text-white transition-colors duration-200 text-left"
              >
                Case Studies
              </button>
              <button
                onClick={() => scrollToSection('collaborate')}
                className="text-white/80 hover:text-white transition-colors duration-200 text-left"
              >
                Collaborate
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-[#2563EB] hover:bg-[#1d4ed8] text-white w-full"
              >
                Get Started
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
